export const heroImageURL =
  "https://firebasestorage.googleapis.com/v0/b/pashias-dental.appspot.com/o/images%2Froom-1-chair-3.webp?alt=media&token=77bdbcf7-25bb-4890-945e-a9dac6198668";

export const contactImageURL =
  "https://firebasestorage.googleapis.com/v0/b/pashias-dental.appspot.com/o/images%2Froom-1-hall-view.webp?alt=media&token=d3987570-8a75-46aa-bf3f-8bc2ac3f8e2a"

export const teamImageURL =
  "https://firebasestorage.googleapis.com/v0/b/pashias-dental.appspot.com/o/images%2Fteam.webp?alt=media&token=61ad893b-5839-4cbf-a2fd-037ce4e26fc1";
